<template>
  <div class="nuevo-usuario-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="nuevo-usuario-shell">
      <!-- Header -->
      <header class="page-header fade-in">
        <div>
          <h1 class="page-title">Registrar usuario</h1>
          <p class="page-sub">Crea un nuevo usuario del sistema</p>
        </div>
        <button class="btn-ghost" @click="$router.push('/usuarios')">
          <v-icon size="15" class="mr-2">mdi-arrow-left</v-icon>
          Volver
        </button>
      </header>

      <!-- Form Content -->
      <section class="fade-in delay-100">
        <div class="card-flat">
          <div class="card-flat-head">
            <span class="section-eyebrow">
              <span class="tick-mark"></span>
              Información del usuario
            </span>
          </div>
          <div class="card-flat-body">
            <form-usuario :usuario="usuario" @registrado="onRegistrado" />
          </div>
        </div>
      </section>

      <!-- Info -->
      <section class="fade-in delay-200 mt-lg">
        <div class="info-box">
          <v-icon size="18" color="#8C8C93" class="mr-3 info-icon">mdi-information-outline</v-icon>
          <div>
            <div class="info-title">Contraseña temporal</div>
            <div class="info-text">
              Se generará una contraseña temporal automáticamente. El usuario deberá cambiarla después del primer
              inicio de sesión.
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Loading Overlay -->
    <div v-if="cargando" class="loading-overlay">
      <div class="loading-inner">
        <div class="spinner"></div>
        <p class="loading-text">Registrando usuario…</p>
      </div>
    </div>

    <!-- Snackbar -->
    <v-snackbar v-model="mostrarMensaje" :timeout="4000" :color="mensaje.color" top right>
      <div class="flex items-center gap-md">
        <v-icon color="white">{{ mensajeIcon }}</v-icon>
        <div>
          <div class="font-semibold">{{ mensaje.titulo || 'Notificación' }}</div>
          <div class="text-sm">{{ mensaje.texto }}</div>
        </div>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small @click="mostrarMensaje = false" v-bind="attrs">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import FormUsuario from './FormUsuario.vue'

export default {
  name: "NuevoUsuario",
  components: { FormUsuario },

  data: () => ({
    cargando: false,
    usuario: {
      usuario: "",
      nombre: "",
      telefono: "",
      rol: ""
    },
    mostrarMensaje: false,
    mensaje: {
      texto: "",
      color: "",
      titulo: ""
    },
  }),

  computed: {
    mensajeIcon() {
      switch (this.mensaje.color) {
        case 'success': return 'mdi-check-circle'
        case 'error': return 'mdi-alert-circle'
        case 'warning': return 'mdi-alert'
        default: return 'mdi-information'
      }
    }
  },

  methods: {
    generarPasswordAleatoria(longitud = 12) {
      const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';
      let password = '';
      for (let i = 0; i < longitud; i++) {
        password += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
      }
      return password;
    },

    async onRegistrado(usuario) {
      this.cargando = true
      this.usuario = usuario
      console.log(this.usuario)

      const passwordTemporal = this.generarPasswordAleatoria();

      let payload = {
        metodo: "registrar",
        usuario: this.usuario,
        password: passwordTemporal,
        rol: this.rol,
      }

      try {
        const resultado = await HttpService.registrar(payload, "usuarios.php")

        if (resultado) {
          this.mostrarMensaje = true
          this.mensaje = {
            titulo: "Usuario registrado",
            texto: "Recuerda cambiar la contraseña editando el usuario",
            color: "success"
          }

          // Limpiar formulario
          this.usuario = {
            usuario: "",
            nombre: "",
            telefono: "",
            rol: ""
          }

          // Redirigir después de 2 segundos
          setTimeout(() => {
            this.$router.push({ name: "Usuarios" })
          }, 2000)
        }
      } catch (error) {
        console.error('Error registrando usuario:', error)
        this.mostrarMensaje = true
        this.mensaje = {
          titulo: "Error",
          texto: "No se pudo registrar el usuario",
          color: "error"
        }
      } finally {
        this.cargando = false
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.nuevo-usuario-page {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
}

.nuevo-usuario-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(242, 242, 237, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.nuevo-usuario-shell {
  position: relative;
  z-index: 1;
  max-width: 720px;
  margin: 0 auto;
}

/* ===== HEADER ===== */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.page-title {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
}

.page-sub {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== CARD ===== */
.card-flat {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.card-flat-head {
  padding: 18px 24px;
  border-bottom: 1px solid var(--card-border);
}

.section-eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.tick-mark {
  width: 12px;
  height: 1px;
  background: var(--accent);
}

.card-flat-body {
  padding: 24px;
}

/* ===== INFO BOX ===== */
.info-box {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 14px 16px;
}

.info-icon {
  margin-top: 1px;
}

.info-title {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.info-text {
  font-size: 12.5px;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* ===== LOADING OVERLAY ===== */
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(14, 14, 16, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--card-border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.loading-text {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 { animation-delay: 0.05s; }
.delay-200 { animation-delay: 0.1s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in, .spinner { animation: none; }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .nuevo-usuario-page {
    padding: 20px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .card-flat-body {
    padding: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/NuevoUsuario.vue